import React     from "react";
import PropTypes from "prop-types";
import { values as _values } from "lodash";
import Constants from "../../../configurations/Constants";

import SearchSuggestions from './SearchSuggestions';
import SearchFilter from "./SearchFilter";
import SearchInputField from './SearchInputField';
import SearchTitle from "../common/SearchTitle";
import SearchPostList from "../common/SearchPostList";


export default class SearchDesktopPage extends React.Component {

    static propTypes = {
        query : PropTypes.string,
        onChangeQuery: PropTypes.func,
        types: PropTypes.array,
        contentType         : PropTypes.oneOf([Constants.CONTENT_FILTER.POST, Constants.CONTENT_FILTER.EVENT]),
        onChangeContentType: PropTypes.func,
        locality: PropTypes.object,
        searchLocality: PropTypes.func,
        onChangeLocality: PropTypes.func,
        group : PropTypes.object,
        searchGroup: PropTypes.func,
        onChangeGroup: PropTypes.func,
        onSetGroup: PropTypes.func,
        onSetLocality: PropTypes.func,
        eventDate: PropTypes.string,
        onChangeEventDate: PropTypes.func,
        surroundings        : PropTypes.oneOf(_values(Constants.SURROUNDING_FILTER)),
        onChangeSurroundings: PropTypes.func,
        currentQueryObject: PropTypes.object,
        results: PropTypes.array,
        resultsLocalities: PropTypes.array,
        resultsGroups: PropTypes.array,
        loading: PropTypes.bool,
        onResetFilters: PropTypes.func,
        language: PropTypes.object,
        onChangeLanguage: PropTypes.func
    };

    render = () => (
        <div className="section mywort-search-page">
            <div className="pure-g container row--expanded">
                <div className="pure-u-1 pure-u-sm-16-24 small-centered">
                    <SearchInputField
                        query={this.props.query}
                        onChangeQuery={this.props.onChangeQuery}
                    />
                </div>
            </div>
            <SearchSuggestions
                query={this.props.query}
                groups={this.props.resultsGroups}
                localities={this.props.resultsLocalities}
                onSetGroup={this.props.onSetGroup}
                onSetLocality={this.props.onSetLocality}
            />
            <div className="section section--minor">
                <div className="pure-g container row--expanded">
                    <div className="pure-u-1">
                        <SearchTitle query={this.props.query} />
                    </div>
                </div>
                <div className="pure-g container container--higher-z-index row--expanded mywort-search-page__search-filter-container">
                    <div className="pure-u-1">
                        <SearchFilter
                            query={this.props.query}
                            types={this.props.types}
                            selected={this.props.contentType}
                            onChangeQuery={this.props.onChangeQuery}
                            contentType={this.props.contentType}
                            onChangeContentType={this.props.onChangeContentType}
                            locality={this.props.locality}
                            searchLocality={this.props.searchLocality}
                            onChangeLocality={this.props.onChangeLocality}
                            group={this.props.group}
                            searchGroup={this.props.searchGroup}
                            onChangeGroup={this.props.onChangeGroup}
                            eventDate={this.props.eventDate}
                            onChangeEventDate={this.props.onChangeEventDate}
                            surroundings={this.props.surroundings}
                            onChangeSurroundings={this.props.onChangeSurroundings}
                            onResetFilters={this.props.onResetFilters}
                            language={this.props.language}
                            onChangeLanguage={this.props.onChangeLanguage}
                        />
                    </div>
                </div>
                <div className="pure-g container row--expanded">
                    <div className="pure-u-1">
                        <section className="mywort-teaser-list">
                            <SearchPostList
                                results={this.props.results}
                                loading={this.props.loading}
                                onResetFilters={this.props.onResetFilters}
                            />
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/search/desktop/SearchDesktopPage.jsx